import React from 'react'

interface Props {
    priority: string | null | undefined
}

const PriorityFormat = ({ priority }: Props) => {
  switch (priority) {
    case 'low':
      return <span className="text-xs font-medium bg-neutral-600 text-neutral-100 px-1 py-0.5 rounded-sm">Laag</span>
    case 'medium':
      return <span className="text-xs font-medium bg-amber-600 text-amber-100 px-1 py-0.5 rounded-sm">Gemiddeld</span>
    case 'high':
      return <span className="text-xs font-medium bg-red-600 text-red-100 px-1 py-0.5 rounded-sm">Hoog</span>
    default:
      return <span></span>
  }
}

export default PriorityFormat